module.exports = __webpack_public_path__ + "media/components/country-flag/static/pf-89406f3f649b38d27c9a084ea9dc0064.svg";